const initializeUserPresenceSummary = () => {
  const placeholders = document.querySelectorAll(".jsUserPresenceSummary");

  if (placeholders.length > 0) {
    const { articleId } = placeholders[0].dataset;
    if (/^\d+$/.test(articleId)) {
      fetch(`/async_info/user_presence_summary?article_id=${articleId}`)
        .then((response) => response.json())
        .then((data) => {
          placeholders.forEach((placeholder) => {
            placeholder.innerHTML = data.summary;
          });
        });
    }
  }
};

// NOTE: esbuild IIFE バンドルではモジュールスコープが分離されるため、グローバルに公開する

export default initializeUserPresenceSummary;